import { Box } from '@mui/material';
import Header from '../components/Header';
import ProductGrid from '../components/ProductGrid';
import Footer from '../components/Footer';
import { colors, layout } from '../theme/tokens';

const HomePage = () => (
  <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
    <Header />
    <Box sx={{ background: colors.gradient.banner, pt: `${layout.headerHeight + 100}px`, flex: 1, display: 'flex', flexDirection: 'column' }}>
      <ProductGrid />
      <Footer />
    </Box>
    {/* <HelpButton /> */}
  </Box>
);

export default HomePage;
